import { useEffect, useState, useRef } from 'react';
import styles from './style.module.css';
import Portal from '../../utils/Portal';
import { useLocation } from 'react-router-dom';

export default function ContextMenu({
    renderBtn,
    renderMenu,
    useBounding=true,
    menuClassName=null,
    menuAnchor='rightTop',
    menuHeight=0,
    menuShow=false
}){
    const [isShow,setIsShow]=useState(false);
    const [pos,setPos]=useState({x:0,y:0})
    const ref=useRef(null)
    const menuRef=useRef(null);
    const location = useLocation();

    useEffect(()=>{
        setIsShow(false);

    },[location])

    const handleClick=(e)=>{
        e.stopPropagation();
        if(useBounding){
            const btnRect=ref.current.getBoundingClientRect();
            if(menuAnchor==='rightTop'){
                setPos({
                    x:btnRect.right + 10,
                    y:btnRect.top
                })
            }else if(menuAnchor==='rightBottom'){
                setPos({
                    x:btnRect.right + 10,
                    y:btnRect.bottom - menuHeight
                })
            }
        }else{
            setPos({
                x:e.clientX,
                y:e.clientY
            })
        }
        setIsShow(true);
    }

    const handleOutsideClick=(e)=>{
        if(ref.current && !ref.current.contains(e.target)){
            if(menuShow){
                if(menuRef.current && !menuRef.current.contains(e.target)){
                    setIsShow(false);
                }
            }
            else{
                setIsShow(false);
            }
        }
    }

    useEffect(()=>{
        if(isShow){
            document.addEventListener('mousedown',handleOutsideClick);
        }else{
            document.removeEventListener('mousedown',handleOutsideClick);
        }
        return()=>{
            document.removeEventListener('mousedown',handleOutsideClick);
        }
    },[isShow])

    return(
        <>
        {renderBtn({
            ref:ref,
            onClick:handleClick
        })} 
        {isShow&&(<Portal>
            <div
            ref={menuRef}
            className={`${styles['wrap']} ${menuClassName}`}
            style={{
                top:pos.y, 
                left:pos.x,
                position:'absolute'
            }}>
                {renderMenu()}
            </div>
        </Portal>)}
        </>
    )
}